export default "__VITE_ASSET__CGKIVGf2__"